import { palette } from '../theme';

export const isBugWorkItem = (workItemType: string, title?: string | null): boolean => {
    if (workItemType.trim().toLowerCase() === 'bug') {
        return true;
    }
    const t = (title ?? '').trim().toLowerCase();
    return t.startsWith('bug:') || t.startsWith('bug ') || t.startsWith('bug-') || t === 'bug';
};

export const workItemTypeAccent = (workItemType: string, title?: string | null): string =>
    isBugWorkItem(workItemType, title) ? palette.bugAccent : palette.loggedAccent;
